import { render, staticRenderFns } from "./selfMark.vue?vue&type=template&id=a00653a8&scoped=true&"
import script from "./selfMark.vue?vue&type=script&lang=js&"
export * from "./selfMark.vue?vue&type=script&lang=js&"
import style0 from "./selfMark.vue?vue&type=style&index=0&id=a00653a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00653a8",
  null
  
)

export default component.exports